export const FEDOPS_WIDGET_APP_NAME = 'bookings-widget-phase-one';

export const FEDOPS_MAIN_PAGE_NAME = 'bookings-main-page';

export const SENTRY_BOOKINGS_WIDGET_DSN =
  'https://487dbfbf210c492cac29cec41461385a@sentry.wixpress.com/173';
